import * as Immutable from "immutable";
export default class Team {
  constructor(id, name, description, users, roles, authServiceId, authServiceUid, type) {
    this._value = {
      id,
      name,
      description,
      users: users != null ? users : Immutable.Set(),
      roles: roles != null ? roles : Immutable.Set(),
      authServiceId,
      authServiceUid,
      type
    };
  }
  get id() {
    return this._value.id;
  }
  get name() {
    return this._value.name;
  }
  get description() {
    return this._value.description;
  }
  get users() {
    return this._value.users;
  }
  get roles() {
    return this._value.roles;
  }
  get authServiceId() {
    return this._value.authServiceId;
  }
  get authServiceUid() {
    return this._value.authServiceUid;
  }
  get type() {
    return this._value.type;
  }
  get isSynced() {
    return this._value.type === "SYNCED";
  }
  toBuilder() {
    const { id, name, description, users, roles, authServiceId, authServiceUid, type } = this._value;
    return new Builder(
      Immutable.Map({
        id,
        name,
        description,
        users,
        roles,
        authServiceId,
        authServiceUid,
        type
      })
    );
  }
  static builder() {
    return new Builder(Immutable.Map({}));
  }
  static create(id, name, description, users, roles, authServiceId, authServiceUid, type) {
    return new Team(id, name, description, users, roles, authServiceId, authServiceUid, type);
  }
  static empty() {
    return Team.create("", "", "", Immutable.Set(), Immutable.Set(), void 0, void 0, "INTERNAL");
  }
  toJSON() {
    const {
      id,
      name,
      description,
      users = Immutable.Set(),
      roles = Immutable.Set(),
      authServiceId,
      authServiceUid,
      type
    } = this._value;
    return {
      id,
      name,
      description,
      users: users.toJS(),
      roles: roles.toJS(),
      auth_service_id: authServiceId,
      auth_service_uid: authServiceUid,
      type
    };
  }
  static fromJSON(value) {
    const {
      id,
      name,
      description,
      roles = [],
      users = [],
      auth_service_id: authServiceId,
      auth_service_uid: authServiceUid,
      type
    } = value;
    return Team.create(
      id,
      name,
      description,
      Immutable.Set(users),
      Immutable.Set(roles),
      authServiceId,
      authServiceUid,
      type
    );
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  users(value) {
    return new Builder(this.value.set("users", value));
  }
  roles(value) {
    return new Builder(this.value.set("roles", value));
  }
  authServiceId(value) {
    return new Builder(this.value.set("authServiceId", value));
  }
  authServiceUid(value) {
    return new Builder(this.value.set("authServiceUid", value));
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  build() {
    const { id, name, description, users, roles, authServiceId, authServiceUid, type } = this.value.toObject();
    return new Team(id, name, description, users, roles, authServiceId, authServiceUid, type);
  }
}
